"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var React = require("react");
var react_1 = require("react");
/**
 * Render the result of dispatching to the `map` method of `target`
 * passing the `with` function as the first argument.
 */
function Map(_a) {
    var target = _a.target, _with = _a["with"];
    return react_1.createElement(React.Fragment, null, target.map(_with));
}
exports.Map = Map;
Map.propTypes = {
    target: PropTypes.any.isRequired,
    with: PropTypes.func.isRequired
};
//# sourceMappingURL=map.js.map